
import React, {Component} from "react";

import "./saint-patricks-day-easter-egg.css";

class SaintPatricksDayEasterEgg extends Component {
    constructor(props) {
        super(props);

        this.state = {
            canClickLep: true,
            showLep: false,
            lepRight: "220px",
            shakeLep: false
        };

        setTimeout(this.setShakeLep.bind(this), 10000);
    }

    setShakeLep(newShouldShake) {
        let {showLep} = this.state;
        if (typeof shouldShake === "undefined") {
            let {shakeLep} = this.state;
            newShouldShake = !shakeLep;
        }

        if (showLep) {
            newShouldShake = false;
        }


        if (newShouldShake) {
            setTimeout(this.setShakeLep.bind(this), 1000);
        }
        else {
            setTimeout(this.setShakeLep.bind(this), 10000);
        }

        this.setState({shakeLep: newShouldShake});
    }

    newLepPosition() {
        let newLepRight = Math.floor((Math.random() * 400) + 220);

        newLepRight = newLepRight + "px";
        this.setState({lepRight: newLepRight});
    }

    lepSoundEnd () {
        if (this.state.canClickLep) {
            return;
        }

     
        this.setState({canClickLep: true, showLep: false});

        setTimeout(this.newLepPosition.bind(this), 500);
    }

    playLepSound () {
        if (!this.state.canClickLep) {
            return;
        }
        
        this.setState({canClickLep: false, showLep: true, shakeLep: false});

        var soundArray = ["lep_sound_1.wav", "lep_sound_2.wav", "lep_sound_3.wav", "lep_sound_4.wav"];

        var randomGobbleIndex = Math.floor(Math.random() * soundArray.length); 


        if (randomGobbleIndex > soundArray.length - 1) {
            randomGobbleIndex = soundArray.length - 1;
        }
        let filename = soundArray[randomGobbleIndex];
        let soundURL = require(`./lep_sounds/${filename}`);
        let audio = new Audio();
        audio.src = soundURL;
        audio.onended = this.lepSoundEnd.bind(this);
        audio.play();
    }   

 

    render() {
        const {showLep, lepRight, shakeLep} = this.state;

        let lepClass = "leprechaun";

        let lepStyle = {
            right: lepRight
        }

        if (showLep) {
            lepClass += " show_lep";
        }

        if (shakeLep) {
            lepClass += " shake"
        }

        let lepImage = "lep.svg";
        return (
            <div>
                <img title='Click Me...' style={lepStyle} alt='patricks_leprechaun' className={lepClass} onClick={this.playLepSound.bind(this)} src={require(`./${lepImage}`)}></img>
            </div>
        )
    }
}

export default SaintPatricksDayEasterEgg;


// WEBPACK FOOTER //
// ./src/components/containers/play-screen/easter-eggs/saint_patricks_day/saint-patricks-day-easter-egg.js